// Vendors
import { reloadedThemes } from '@openbank/ziniaweb-ui-components';

const THEME_PROVIDER_PROPS = {
  theme: reloadedThemes.cobranded_light_regular,
};

export { THEME_PROVIDER_PROPS };
